"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _ramda = require("ramda");
var _reactI18next = require("react-i18next");
var _moment = _interopRequireDefault(require("moment"));
var _price = require("../../../../../../helpers/price");
var _selectors = require("../../store/selectors");
var _AdditionalHotelInfo = require("../AdditionalHotelInfo");
var _scheduleBookingPaymentIcon = _interopRequireDefault(require("./img/scheduleBookingPaymentIcon.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SHORT_DATE_FORMAT = 'DD MMMM';
var DATE_FORMAT = 'DD MMMM HH:mm';
var mapIndexed = (0, _ramda.addIndex)(_ramda.map);
var getIsFullDate = function getIsFullDate(stringDate) {
  var momentDate = (0, _moment.default)(stringDate);
  return momentDate.hours() || momentDate.minutes();
};
var renderContent = function renderContent(_ref) {
  var percent = _ref.percent,
    price = _ref.price,
    currency = _ref.currency;
  return percent ? "".concat(percent, "%") : (0, _price.preparePriceForRender)(price[currency], currency);
};
var ScheduleBookingPayments = function ScheduleBookingPayments() {
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.getBootstrapOffer),
    scheduleOfBookingPayments = _useSelector.scheduleOfBookingPayments;
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_DETAILS'),
    t = _useTranslation.t;
  return scheduleOfBookingPayments && /*#__PURE__*/_react.default.createElement(_AdditionalHotelInfo.AdditionalHotelInfo, {
    title: t('SCHEDULE_BOOKING_PAYMENTS_TITLE'),
    icon: _scheduleBookingPaymentIcon.default
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: _styles.default.list
  }, mapIndexed(function (_ref2, i) {
    var price = _ref2.price,
      currency = _ref2.currency,
      dueDate = _ref2.dueDate,
      percent = _ref2.percent;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: i
    }, t('SCHEDULE_BOOKING_PAYMENT_TITLE', {
      content: renderContent({
        percent: percent,
        currency: currency,
        price: price
      }),
      dueDate: (0, _moment.default)(dueDate).format(getIsFullDate(dueDate) ? DATE_FORMAT : SHORT_DATE_FORMAT)
    }));
  }, scheduleOfBookingPayments)));
};
var _default = exports.default = (0, _react.memo)(ScheduleBookingPayments);